import React from 'react';
import { ThemeProvider, createTheme, CssBaseline, Container, Typography } from '@mui/material';
import OptimizerPage from './components/OptimizerPage';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

function App() {
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <Container maxWidth="lg" sx={{ my: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom align="center">
          Farming Profit Optimizer 🚜
          <div style={{color: "red"}}>Under Construction</div>
        </Typography>
        <OptimizerPage />
      </Container>
    </ThemeProvider>
  );
}

export default App;